import { GetTimeseriesRequest } from "../types/timeseries";
import { useQuery } from "react-query";
import useQueryState from "./useQueryState";
import { getClimateTimeseriesByGeographicalUnit } from "../services/timeseries";
import { kebabCase } from "lodash";
import Cookies from "js-cookie";
import { useAuthContext } from "./useAuthContext";
import { useUIStore } from "../store/ui";

const accessToken = () => Cookies.get("accessToken");

export type UseTimeseries = GetTimeseriesRequest;

const useClimateTimeseries = ({ isEnabled }: { isEnabled: boolean }) => {
  const {
    queryState: { country, geographicalUnit, aggregationLevel, climate },
  } = useQueryState();
  const { parsedToken } = useAuthContext();
  const { email: userEmail } = parsedToken || {};
  const isSystemType =
    aggregationLevel === "0" ||
    aggregationLevel === "1" ||
    aggregationLevel === "2";
  const isLandCoverMasked = useUIStore((s) => s.isLandCoverMasked);

  const getClimateTimeseries = useQuery(
    [
      "timeseries",
      country,
      climate,
      geographicalUnit,
      aggregationLevel,
      isSystemType ? "system" : "user",
      accessToken() ? userEmail : "",
      isLandCoverMasked,
    ],
    async () => {
      return await getClimateTimeseriesByGeographicalUnit({
        country,
        indicator: `${kebabCase(climate)}${isLandCoverMasked ? "-masked" : ""}`,
        locationId: geographicalUnit,
        adminLevel: aggregationLevel,
        type: isSystemType ? "system" : "user",
      });
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
      enabled:
        Boolean(country && climate && geographicalUnit && aggregationLevel) &&
        isEnabled,
    },
  );

  return {
    getClimateTimeseries,
  };
};

export default useClimateTimeseries;
